var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2D4BF3",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 219.328 219.328",
    xmlSpace: "preserve",
    stroke: "#2D4BF3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.726,30.746c-0.086-0.096-0.168-0.195-0.26-0.287c-0.198-0.198-0.406-0.381-0.62-0.552 C165.201,11.377,138.738,0,109.666,0C49.198,0,0.003,49.196,0.003,109.668c0.002,29.059,11.369,55.51,29.884,75.152 c0.177,0.224,0.365,0.441,0.572,0.647c0.107,0.106,0.22,0.2,0.331,0.299c19.957,20.679,47.94,33.562,78.877,33.562 c60.466,0,109.659-49.193,109.659-109.661C219.325,78.707,206.427,50.706,185.726,30.746z M109.666,15 c22.538,0,43.256,7.923,59.53,21.123L36.125,169.194c-13.198-16.273-21.12-36.991-21.122-59.527C15.003,57.468,57.469,15,109.666,15 z M109.666,204.328c-24.269,0-46.432-9.186-63.204-24.258l133.61-133.609c15.07,16.772,24.253,38.936,24.253,63.206 C204.325,161.863,161.861,204.328,109.666,204.328z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.ea21dbcddd009e223d34f3966e9f23a5.svg";
export { ForwardRef as ReactComponent };